import * as Api from '@ViewModels';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useEventLogging } from '../../../../../../models/Logging';
import { Button } from '../../../../../components-v2/Button';
import { ROUTES } from '../../../../../constants/routes';
import { AgentRow, AgentRowIcon } from '../../AgentRow';
import { nextDeliveryLabel } from './helpers';
import { MEETING_PREP_TELEMETRY_CATEGORY } from './DashboardMeetingPrepRow';
import { CalendarIcon } from '@WebComponents/svgs/icons/CalendarIcon';

export const DashboardMeetingPrepFirstRunRow: FC<{
	template: Api.MeetingPrepTemplate;
	timeZone: string;
}> = ({ template, timeZone }) => {
	const history = useHistory();
	const { logEvent } = useEventLogging(MEETING_PREP_TELEMETRY_CATEGORY);
	const scheduleEnabled = !!template.scheduleEnabled;

	const goToSettings = () => {
		logEvent('SettingsClicked', { scheduleEnabled });
		history.push(ROUTES.meetingPrep.settings);
	};

	return (
		<AgentRow
			icon={
				<AgentRowIcon>
					<CalendarIcon />
				</AgentRowIcon>
			}
			title='Meeting Prep'
			detail={
				scheduleEnabled
					? `Your first briefs arrive ${nextDeliveryLabel(template, timeZone)}.`
					: 'Turn on delivery to start getting briefs before your meetings.'
			}
			action={
				<Button size='sm' variant={scheduleEnabled ? 'secondary' : 'primary'} onClick={goToSettings}>
					{scheduleEnabled ? 'Settings' : 'Turn on delivery'}
				</Button>
			}
		/>
	);
};
